import React from "react";

function WalkaroundGuide() {
  const handlePrint = (event) => {
    event.preventDefault();
    window.print();
  };

  return (
    <>
      {/* Walkaround Guide Content */}
      <div id="WalkaroundGuide" className="p-6 bg-white">
        <h2 className="text-3xl font-bold mb-4 text-center">🚐 PSV Drivers' Walk Around Check 🚐</h2>
        <p className="text-center text-lg mb-6">
          <a href="http://www.transaid.org" target="_blank" rel="noopener noreferrer">www.transaid.org</a>
        </p>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Body Exterior</h3>
          <ul className="list-disc ml-6">
            <li>No visible damage or wear.</li>
            <li>The floor is sound with no areas of weakness, all seats and floor traps are secure (no trip hazards) and not obstructing fire exits.</li>
            <li>All exterior lights are working correctly.</li>
            <li>Interior lights are present, working, and in correct location.</li>
            <li>All electrical equipment is working correctly.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Mirrors and Glass</h3>
          <ul className="list-disc ml-6">
            <li>Check all mirrors that should be there.</li>
            <li>Are they securely mounted?</li>
            <li>Check that all mirrors are clean and unobstructed from the driver's view.</li>
            <li>Check that all windows are not damaged or obscured in a way that obscures the view.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Fuel/Oil Levels and Leaks</h3>
          <ul className="list-disc ml-6">
            <li>Check all fuel, engine oil, coolant, windscreen washer and (if fitted) extra levels.</li>
            <li>Check that all lids are on securely.</li>
            <li>Check for leaks underneath the vehicle, especially around the engine.</li>
            <li>Check underneath vehicle for any leaks of fuel/oil.</li>
            <li>Check if all tanks are full and do not leak.</li>
            <li>Check for power steering fluid leaks.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Steering</h3>
          <ul className="list-disc ml-6">
            <li>Check the steering for excessive play.</li>
            <li>Check for power steering fluid leaks.</li>
            <li>Check for leaks underneath the vehicle, especially around the steering column.</li>
            <li>Check to ensure that all parts are present, secure and undamaged.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Emergency Equipment</h3>
          <ul className="list-disc ml-6">
            <li>Check all equipment is present and ready for immediate use.</li>
            <li>Check that the warning triangle is present and ready for use.</li>
            <li>Check that all warning devices are functioning correctly.</li>
            <li>Check the fire extinguisher is in a good condition.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">First Aid Kit</h3>
          <ul className="list-disc ml-6">
            <li>Check the first aid kit is present and complete.</li>
            <li>Check the first aid kit is in a good condition.</li>
            <li>Check the first aid kit is easily accessible.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Fire Extinguisher</h3>
          <ul className="list-disc ml-6">
            <li>Check that the fire extinguisher is easily accessible.</li>
            <li>Check that the fire extinguisher is in a good condition and not damaged.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Tyres and Wheel Rims</h3>
          <ul className="list-disc ml-6">
            <li>Check each tyre and wheel rim for any damage.</li>
            <li>Check for wheel nuts that are on securely.</li>
            <li>Check for excessive wear on each tyre.</li>
            <li>Check the inflation of all tyres.</li>
            <li>Check for punctures.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Driver's Compartment</h3>
          <ul className="list-disc ml-6">
            <li>Check that the driver's seat is secure.</li>
            <li>Check all seatbelts are present and working correctly.</li>
            <li>Check that all buttons, switches and levers are present and working correctly.</li>
            <li>Check that all instruments and displays are working correctly.</li>
            <li>Check that the battery is held in place.</li>
            <li>Check that all cables are not damaged.</li>
            <li>Check that all fuses are in the fusebox.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">Brakes</h3>
          <ul className="list-disc ml-6">
            <li>Check for any signs of brake fluid leaks.</li>
            <li>Check that all brake lines are not damaged.</li>
            <li>Check for any signs of brake pad wear.</li>
            <li>Check that all brake lights are working correctly.</li>
            <li>Check that the handbrake is working correctly.</li>
            <li>Check that the ABS light is working correctly.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-bold">External Vehicle</h3>
          <ul className="list-disc ml-6">
            <li>Check that the body panels, luggage compartment and engine compartment are all secure and not damaged.</li>
            <li>Check that the luggage compartment is secure.</li>
            <li>Check that the vehicle registration plate is in place.</li>
            <li>Check the windscreen wipers are working correctly.</li>
            <li>Check that all lights are working correctly.</li>
          </ul>
        </div>

        {/* Print Button */}
        <div className="mt-4 text-center">
          <button
            type="button"
            onClick={handlePrint}
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition"
          >
            Print Walkaround Guide
          </button>
        </div>
      </div>

      {/* CSS for print functionality */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }

            #WalkaroundGuide, #WalkaroundGuide * {
              visibility: visible;
            }

            #WalkaroundGuide {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 10mm;
              box-shadow: none;
              border: none;
              font-size: 12pt;
            }

            @page {
              size: A4 portrait;
              margin: 20mm;
            }

            .print-button {
              display: none;
            }
          }
        `}
      </style>
    </>
  );
}

export default WalkaroundGuide;
